/** Display and internal identifiers for sections and questions (not shown to authors). */

/** Internal section code stored in DB — e.g. S1, S2, S1_1 for subsections. */
export function internalSectionCode(
  sectionIndex: number,
  parentSectionIndex?: number
): string {
  const n = sectionIndex + 1;
  if (parentSectionIndex != null) {
    return `S${parentSectionIndex + 1}_${n}`;
  }
  return `S${n}`;
}

/** Internal question key stored in DB — scoped to section code. */
export function internalQuestionKey(sectionCode: string, questionIndex: number): string {
  return `${sectionCode}_Q${questionIndex + 1}`;
}

export function sectionDisplayLabel(
  sectionNumber: number,
  depth: number,
  parentSectionNumber?: number
): string {
  if (depth > 0 && parentSectionNumber != null) {
    return `${parentSectionNumber}.${sectionNumber}`;
  }
  return String(sectionNumber);
}

export function questionDisplayNumber(questionIndex: number): number {
  return questionIndex + 1;
}
